import { createContext, useContext, type PropsWithChildren } from 'react';

import { type SessionListHost } from './session-list-host';

const SessionListHostContext = createContext<SessionListHost | null>(null);

/** The schedule-upload modal mounts this so inner files read one host. */
export const SessionListHostProvider = ({
  host,
  children,
}: PropsWithChildren<{ host: SessionListHost }>) => (
  <SessionListHostContext.Provider value={host}>
    {children}
  </SessionListHostContext.Provider>
);

/** Throws when an upload module renders outside the provider. */
export const useSessionListHost = (): SessionListHost => {
  const host = useContext(SessionListHostContext);
  if (!host) {
    throw new Error('Session list host read outside SessionListHostProvider');
  }
  return host;
};
